import { render, staticRenderFns } from "./TerminalIcon.vue?vue&type=template&id=b35bc624"
import script from "./TerminalIcon.vue?vue&type=script&lang=js"
export * from "./TerminalIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports